// @owners { team: patients }
import { type ReduxStateShared } from '~shared/store';

export const getAddFamilyMemberRelationship = (state: ReduxStateShared) => state.ui.addFamilyMember.relationship;
